import  env from '@utils/env';
import { BlobServiceClient, BlobUploadCommonResponse, ContainerClient,BlockBlobParallelUploadOptions } from '@azure/storage-blob';

export const containerName = `files`;
export const containerNameBrands = `brands`;
export const containerNameExternals = `externals`;
export const storageAccountName = env === "qa" ? "qadscloudstorage" : 
                                  env === "prod" ? "proddscloudstorage" :
                                  env === "uat" ? "uatdscloudstorage" : "devdscloudstorage";

export const resizeStorageAccountName = env === "qa" ? "https://qadsresizeimage.azureedge.net" : 
                                        env === "prod" ? "https://proddsresizeimage.azureedge.net" :
                                        env === "uat" ? "https://uatdsresizeimage.azureedge.net" : 
                                        "http://localhost:7071/api/ResizeImage";

let sasToken = ""; 

export const isStorageConfigured = () => {
  return (!storageAccountName || !sasToken) ? false : true;
}

const createFileInContainer = async (containerClient: ContainerClient, file: File) => {
  const blobClient = containerClient.getBlockBlobClient(file.name);
  const options:BlockBlobParallelUploadOptions = { blobHTTPHeaders : { blobContentType: file.type } };
  return await blobClient.upload(file,file.size,options)
}

export const uploadFileToBlob = async (file: File | null, token: string | '', container?: string) => {
  return new Promise<BlobUploadCommonResponse>(async (resolve, reject) => {
    if (!file) return false;
    if (token != '') sasToken = token;
    try {
      // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
      const blobService = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
      );
      // get Container - full public read access
      const containerClient: ContainerClient = blobService.getContainerClient(container ? container : containerName);
      // upload file
      resolve(await createFileInContainer(containerClient, file));
    } catch (e) {
      reject(e);
    }
  })
};



